<template>
    <div>
        <div class="chart-legend">
            <span class="red">总买:<b class="red">{{legend.buyTotalAmt}}万手</b></span>
            <span class="green">总卖:<b class="green">{{legend.saleTotalAmt}}万手</b></span>
            <span class="org">买卖差:<b class="org">{{legend.minusTotalAmt}}万手</b></span>
        </div>
        <div class="chart-wrap" id="dkdbsz-echart-container"><p class="blank">-- 暂无数据 --</p></div>
    </div>
</template>

<script>
    import { queryQuotaInfo } from '@/api/microService'
    import { mapState } from 'vuex'
    export default {
        data () {
            return {
                legend:{buyTotalAmt:"--",saleTotalAmt:"--",minusTotalAmt:"--"},
                chartData:{time:[],buyTotalAmt:[],saleTotalAmt:[],minusTotalAmt:[]}
            }
        },
        computed: {
            ...mapState(['isBlankPage'])
            //this.BlankPage;
        },
        mounted(){
            this.getData();
        },
        methods: {
            convertXToTime:function (x) {
                var MINUTES = 240;    //沪深一天的交易时间
                var AM_MINUTES = 120; //沪深上午交易时间
                var addZero = function (str, length) {
                    return new Array(length - str.toString().length + 1).join('0') + str;
                }
                var startAm = new Date(1970, 1, 1, 9, 30, 0);
                var startPm = new Date(1970, 1, 1, 13, 0, 0);
                var endXAm =  AM_MINUTES;  //上午交易时间段对应的最后一个x序列的值(2个小时,120分钟)
                if (x <= endXAm) {
                    var time = new Date(+startAm + 60000 * x);  //获得当前时间=起始时间 + 1分钟 * X
                } else {
                    var time = new Date(+startPm + 60000 * (x - endXAm));  //获得当前时间=起始时间 + 1分钟 * (X - 上午最后一个X - 1)
                }
                return [addZero(time.getHours(), 2), addZero(time.getMinutes(), 2)].join(':');
            },
            getData:function(){
                var _this=this;
                // 调用微信服务测试
                dzhMicroToken
                    .then(response => {
                            // 执行成功的回调函数
                            if(response.resCode==="000000") {
                                var data     ={
                                    "merId":"MER201805260001",
                                    "busiCode":"2924",
                                    "token":response.resData.token,
                                    "reqData":{
                                        "code":"SZ399001",
                                        "pos":0
                                    }
                                };
                                queryQuotaInfo(data).then(response => {
                                    var res=response.data;
                                    if(res.resCode==="000000") {
                                        if(res.resData.quotaTotalInfo!=undefined && res.resData.quotaTotalInfo.length>0){
                                            for(var i=0;i<res.resData.quotaTotalInfo.length;i++){
                                                var buyTotalAmt        =Math.round(res.resData.quotaTotalInfo[i].buyTotalAmt/10000);
                                                var saleTotalAmt       =Math.round(res.resData.quotaTotalInfo[i].saleTotalAmt/10000);
                                                var minusTotalAmt      =Math.abs(Math.round((res.resData.quotaTotalInfo[i].buyTotalAmt-res.resData.quotaTotalInfo[i].saleTotalAmt)/10000));
                                                var time               =this.convertXToTime(i);
                                                this.chartData.time.push(time);
                                                if(i>30 && res.resData.quotaTotalInfo[i].buyTotalAmt==0 && res.resData.quotaTotalInfo[i].saleTotalAmt==0){
                                                    this.chartData.buyTotalAmt.push(this.chartData.buyTotalAmt.pop());
                                                    this.chartData.saleTotalAmt.push(this.chartData.saleTotalAmt.pop());
                                                    this.chartData.minusTotalAmt.push(this.chartData.minusTotalAmt.pop());
                                                }else{
                                                    this.chartData.buyTotalAmt.push(buyTotalAmt);//涨停家数
                                                    this.chartData.saleTotalAmt.push(saleTotalAmt);//跌停家数
                                                    this.chartData.minusTotalAmt.push(minusTotalAmt);//非一字涨停
                                                }
                                            }
                                            this.legend.buyTotalAmt=this.chartData.buyTotalAmt[this.chartData.buyTotalAmt.length - 1];
                                            this.legend.saleTotalAmt=this.chartData.saleTotalAmt[this.chartData.saleTotalAmt.length - 1];
                                            this.legend.minusTotalAmt=this.chartData.minusTotalAmt[this.chartData.minusTotalAmt.length - 1];
                                        }
                                        if(!this.isBlankPage && this.chartData.buyTotalAmt.length>0 && this.chartData.saleTotalAmt.length>0 && this.chartData.minusTotalAmt.length>0){
                                            this.myChart();
                                        }
                                    }
                                });
                            }
                        },
                        error => {
                            // 执行失败的回调函数
                            //console.log(error);
                        })
            },
            myChart:function(){
                self=this
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('dkdbsz-echart-container'),'white');
                // 绘制图表
                // 指定图表的配置项和数据
                var chartOption = {
                    backgroundColor: '#FFFFFF',
                    title: {
                        show: true,
                        //text: '沪深涨跌停走势',
                        textStyle: {
                            color: '#222',
                            fontSize: 12,
                            fontWeight: 'normal'
                        },
                        z: 2,
                        left: 30,
                        top: '-5px'
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#406cc2',
                        textStyle: {
                            color: "#fff",
                            fontSize: 12
                        },
                        position: function (point) {
                            // 固定在顶部
                            // return [point[0], '0'];
                        },
                        padding: [5, 10],
                        confine: true,
                        formatter: function (params) {
                            var string = '';
                            if (!isNaN(params[0].value)) {
                                string += '委买:' + params[0].value + '万手<br/>';
                            }
                            if (!isNaN(params[1].value)) {
                                string += '委卖:' + params[1].value + '万手<br/>';
                            }
                            if (!isNaN(params[2].value)) {
                                string += '买卖委差:' + params[2].value + '万手<br/>';
                            }
                            return (string == '') ? false : params[0].name + '<br/>' + string;
                        },
                        axisPointer: {
                            lineStyle: {color: '#406cc2'},
                        }
                    },
                    color: ['#FF0000','#13a977','#fd8824'],
                    grid: {
                        left: 10,
                        right: 30,
                        top: 20,
                        bottom: 10,
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: false
                    }],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: function(index,name){//index是x轴的坐标序号，name是坐标值
                                var timeLength=self.chartData.time.length-1;
                                var interval
                                if(timeLength<=10){
                                    if(index==0){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }else if(timeLength<=30){
                                    interval=Math.ceil(timeLength/2)
                                    if(index==interval*0){
                                        return true;
                                    }
                                    if(index==interval*1){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }else{
                                    interval=Math.ceil(timeLength/4)
                                    if(index==interval*0){
                                        return true;
                                    }
                                    if(index==interval*1){
                                        return true;
                                    }
                                    if(index==interval*2){
                                        return true;
                                    }
                                    if(index==interval*3){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }
                            },
                            textStyle: {color: '#666', fontSize: 13},
                            formatter: null
                        },
                        axisTick:{
                            show:false //是否显示坐标轴刻度
                        },
                        data: this.chartData.time
                    },
                    yAxis: {
                        type: 'value',
                        scale: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            margin: 2,
                            textStyle: {fontSize: 13}
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {}
                        },
                        splitNumber: 3,
                    },
                    series: [
                        {
                            name: '委买',
                            type: 'line',
                            smooth: true,
                            showSymbol: false,
                            symbol: 'circle',
                            symbolSize: 3,
                            z: 100,
                            itemStyle: {
                                normal: {
                                    borderColor: 'rgba(253, 136, 36, 0.5)',
                                    borderWidth: 5
                                }
                            },
                            data: this.chartData.buyTotalAmt
                        },
                        {
                            name: '委卖',
                            type: 'line',
                            smooth: true,
                            showSymbol: false,
                            symbol: 'circle',
                            symbolSize: 3,
                            z: 100,
                            itemStyle: {
                                normal: {
                                    borderColor: 'rgba(62, 106, 197, 0.5)',
                                    borderWidth: 5
                                }
                            },
                            data: this.chartData.saleTotalAmt
                        },
                        {
                            name: '买卖委差',
                            type: 'line',
                            smooth: true,
                            showSymbol: false,
                            symbol: 'circle',
                            symbolSize: 3,
                            z: 100,
                            itemStyle: {
                                normal: {
                                    borderColor: 'rgba(188, 106, 197, 0.5)',
                                    borderWidth: 5
                                }
                            },
                            data: this.chartData.minusTotalAmt
                        }
                    ]
                };
                myChart.setOption(chartOption);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/dkdbSz.vue